export default [
  {
    path: "/login",
    redirect: "/signin",
  },
  {
    path: "/signin",
    component: () => import("@/views/reports/signin/SignIn.vue"),
  },
  {
    path: "/signin/forgot",
    component: () => import("@/views/reports/signin/ForgotPassword.vue"),
  },
  {
    path: "/signin/workos/redirect",
    component: () => import("@/views/reports/signin/WorkOSRedirect.vue"),
  },
];
